import { Hyperlink } from '@contentful/rich-text-types';
import { removeQueryStringFromUri } from './removeQueryStringFromUri';

export const removeSearchIdentifierFromLinkNode = (
    node: Hyperlink
): Hyperlink => {
    return {
        ...node,
        data: {
            ...node.data,
            uri: removeQueryStringFromUri(node.data.uri, 'search_identifier')
        }
    };
};
